import setReduxAction from 'modules/redux/actions/set'
import getRequestsNetworkSelector from 'modules/training/modules/network/selectors/get-requests'
import { NETWORK_ACTION, NETWORK_PATH } from 'modules/training/modules/network/constants'

function removeRequestNetworkAction (action) {
  return (dispatch, getState) => {
    const requests = getRequestsNetworkSelector()(getState())
    dispatch(
      setReduxAction({
        type: NETWORK_ACTION.DELETE_REQUESTS,
        payload: {
          path: NETWORK_PATH.REQUESTS,
          value: requests.filter(
            request => request.action.payload.path !== action.payload.path
          )
        }
      })
    )
  }
}

export default removeRequestNetworkAction
